import { useMemo, useCallback } from "react";
import { useIntl } from "react-intl";
import { formatPeriodicalsCount } from "../utils/formatUtils";
export var useLibraryTable = function (onRowClick) {
    var formatMessage = useIntl().formatMessage;
    var handleNameClick = useCallback(function (item) {
        onRowClick(item);
    }, [onRowClick]);
    var noAcceptLabel = formatMessage({
        id: "ui-br-legaldeposits.libraries.table.noAccept",
    });
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.libraries.table.name",
            }),
            key: "name",
            sortKey: "name",
            alwaysVisible: true,
            clickable: true,
            onClick: handleNameClick,
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.libraries.table.type",
            }),
            key: "type",
            sortKey: "type",
            cellRenderer: function (item) {
                return formatMessage({
                    id: "ui-br-legaldeposits.libraryType.".concat(item.type),
                });
            },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.libraries.table.region",
            }),
            key: "region",
            sortKey: "region",
            cellRenderer: function (item) { var _a, _b; return (_b = (_a = item.region) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ""; },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.libraries.table.nonPeriodicalsAllRegions",
            }),
            key: "nonPeriodicalsCountAllRegions",
            sortKey: "nonPeriodicalsCountAllRegions",
            cellRenderer: function (item) {
                return formatPeriodicalsCount(item.nonPeriodicalsCountAllRegions, noAcceptLabel);
            },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.libraries.table.nonPeriodicalsOwnRegion",
            }),
            key: "nonPeriodicalsCountOwnRegion",
            sortKey: "nonPeriodicalsCountOwnRegion",
            cellRenderer: function (item) {
                return formatPeriodicalsCount(item.nonPeriodicalsCountOwnRegion, noAcceptLabel);
            },
        },
        {
            name: formatMessage({
                id: "ui-br-legaldeposits.libraries.table.periodicals",
            }),
            key: "periodicalsCount",
            sortKey: "periodicalsCount",
            cellRenderer: function (item) {
                return formatPeriodicalsCount(item.periodicalsCount, noAcceptLabel);
            },
        },
    ]; }, [formatMessage, handleNameClick, noAcceptLabel]);
    return {
        columns: columns,
    };
};
